import { Component, Input } from '@angular/core';
import { IBlog } from '../../interface';
import { I18nService } from '../../../../../core/services/i18n.service';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  standalone: false
})
export class CardComponent {
  @Input('blog') blog!: IBlog

  constructor(public i18nService: I18nService) {

  }
}
